export default __webpack_public_path__ + "static/media/lik.556adb42.png";